import { CpuChipIcon } from '@heroicons/react/24/outline';
import { useTranslation } from 'react-i18next';
import { Card, Text } from '@/shared/ui';

export const EmptyAIAssessmentCard = () => {
  const { t } = useTranslation();
  return (
    <Card variant="accent" className="flex flex-col items-center justify-center gap-3">
      <div className="flex h-12 w-12 items-center justify-center rounded-lg bg-brand-100">
        <CpuChipIcon className="h-6 w-6 text-text-success" />
      </div>
      <Text variant="body" className="font-medium">
        {t('assessment.messages.ai-empty-title')}
      </Text>
      <Text variant="body" className="text-center text-text-secondary">
        {t('assessment.messages.ai-empty-description')}
      </Text>
    </Card>
  );
};
